import Fetch from 'utils/fetch';

export const renegociarComposicaoCarga = (loadCompositionId, composicaoCarga) => {
   return Fetch.post(`/load-compositions/${loadCompositionId}:create-negotiation`, composicaoCarga);
}